<template>
  <footer class="app-footer" :class="{ 'app-footer--with-sidebar': layoutStore.showSidenav }">
    <div class="app-footer__content">
      <div class="app-footer__links">
        <a href="https://notefie.com.au" target="_blank" class="app-footer__link">Home</a>
        <a href="https://notefie.com.au/about" target="_blank" class="app-footer__link">About</a>
        <a href="https://notefie.com.au/contact" target="_blank" class="app-footer__link"
          >Contact</a
        >
        <a href="https://notefie.com.au/privacy-policy/" target="_blank" class="app-footer__link"
          >Privacy Policy</a
        >
        <a href="https://notefie.com.au/terms/" target="_blank" class="app-footer__link"
          >Terms & Conditions</a
        >
      </div>
      <span class="app-footer__text">© {{ currentYear }} Notefie. All rights reserved.</span>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useLayoutStore } from '../stores/layout'

const layoutStore = useLayoutStore()
const currentYear = computed(() => new Date().getFullYear())
</script>

<style lang="scss" scoped>
@import '../assets/_mixins.scss';

.app-footer {
  padding: 1.5rem 2rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  background-color: #e5e5e5 !important;
  margin: 1rem;

  &--with-sidebar {
    @include desktop {
      margin-left: 17.125rem;
    }
  }

  &__content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 1rem;
  }

  &__links {
    display: flex;
    gap: 2rem;
    padding-left: 1rem;
    flex-wrap: wrap;
  }

  &__link {
    font-size: 0.875rem;
    color: #666;
    text-decoration: none;
    transition: color 0.2s;

    &:hover {
      color: #e25a64;
    }
  }

  &__text {
    font-size: 0.875rem;
    color: #666;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .app-footer {
    padding: 1rem;
    margin: 0.5rem;

    &__content {
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 1rem;
      padding: 0;
    }

    &__links {
      justify-content: center;
      gap: 0.75rem 1rem;
      padding-left: 0;
    }

    &__link {
      font-size: 0.8125rem;
    }

    &__text {
      white-space: normal;
      font-size: 0.8125rem;
    }
  }
}
</style>
